import React, { useState, useEffect, useRef } from "react";
import FaceSelector from "./FaceSelector";

const FaceDetect = ({
  imageUrl,
  boundingBoxes,
  Name,
  selectedIndex,
  onSelect,
  width,
  height,
}) => {
  const [imageDimensions, setImageDimensions] = useState({
    naturalWidth: 0,
    naturalHeight: 0,
    clientWidth: 0,
    clientHeight: 0,
  });
  const [imageSrc, setImageSrc] = useState(null);
  const imageRef = useRef(null);

  useEffect(() => {
    const updateDimensions = () => {
      if (imageRef.current) {
        const { naturalWidth, naturalHeight, clientWidth, clientHeight } =
          imageRef.current;
        setImageDimensions({
          naturalWidth,
          naturalHeight,
          clientWidth,
          clientHeight,
        });
      }
    };

    updateDimensions();
    window.addEventListener("resize", updateDimensions);
    return () => window.removeEventListener("resize", updateDimensions);
  }, [imageUrl, boundingBoxes]);

  useEffect(() => {
    if (imageUrl) {
      var Token = window.localStorage.getItem("Token");

      const fetchImage = async () => {
        try {
          const response = await fetch(imageUrl, {
            headers: {
              Authorization: `Bearer ${Token}`,
            },
          });

          if (!response.ok) {
            throw new Error("Network response was not ok");
          }

          const blob = await response.blob();
          const objectUrl = URL.createObjectURL(blob);
          setImageSrc(objectUrl);
        } catch (error) {
          console.error("Error fetching image:", error);
        }
      };

      fetchImage();
    }
  }, [imageUrl]);

  const selectFace = (SelectedIndex) => {
    onSelect(Name, SelectedIndex);
  };

  const adjustBoundingBoxPosition = (x, y, width, height, imageDimensions) => {
    const { naturalWidth, naturalHeight, clientWidth, clientHeight } =
      imageDimensions;

    const scaleX = clientWidth / naturalWidth;
    const scaleY = clientHeight / naturalHeight;

    const scale = Math.min(scaleX, scaleY);

    const offsetX = (clientWidth - naturalWidth * scale) / 2;
    const offsetY = (clientHeight - naturalHeight * scale) / 2;

    return {
      left: x * scale + offsetX,
      top: y * scale + offsetY,
      width: width * scale,
      height: height * scale,
    };
  };

  return (
    <div
      style={{
        position: "relative",
        display: "inline-block",
        maxWidth: width,
        maxHeight: height,
      }}
    >
      {imageSrc && (
        <img
          ref={imageRef}
          src={imageSrc}
          alt="Detected face"
          onLoad={() => {
            if (imageRef.current) {
              const { naturalWidth, naturalHeight, clientWidth, clientHeight } =
                imageRef.current;
              setImageDimensions({
                naturalWidth,
                naturalHeight,
                clientWidth,
                clientHeight,
              });
            }
          }}
          style={{
            display: "block",
            maxWidth: width,
            maxHeight: height,
            objectFit: "contain",
            borderRadius: 10,
          }}
        />
      )}
      {imageDimensions.clientWidth > 0 &&
        boundingBoxes.map((box, index) => {
          const [x1, y1, x2, y2] = box;
          const { left, top, width, height } = adjustBoundingBoxPosition(
            x1,
            y1,
            x2 - x1,
            y2 - y1,
            imageDimensions
          );

          return (
            <FaceSelector
              key={index}
              OnSelect={() => selectFace(index)}
              isSelected={selectedIndex === index}
              style={{
                position: "absolute",
                left: `${left}px`,
                top: `${top}px`,
                width: `${width}px`,
                height: `${height}px`,
                boxSizing: "border-box",
                cursor: "pointer",
              }}
            />
          );
        })}
    </div>
  );
};

export default FaceDetect;
